/**
 * Fuente única de verdad para datos de la empresa.
 * Actualizar aquí propaga a: schema.js, Footer, ContactInfo, OfficesSection,
 * TerminosContent, PrivacidadContent y cualquier otro consumidor.
 */

export const company = {
  name: 'Bison Agents',
  legalName: 'Bison Agents SpA',
  taxID: '78.187.157-5',
  repLegal: {
    name: 'Matías Tapia',
    taxID: '17.756.854-6',
  },
  address: {
    street: 'Los Militares 5620 of 905',
    locality: 'Las Condes',
    region: 'Santiago',
    country: 'Chile',
    countryCode: 'CL',
    postalCode: '7560742',
    display: 'Los Militares 5620 of 905, Las Condes, Santiago, Chile',
  },
  phone: '+569 6713 0127',
  tel: 'tel:+56967130127',
  whatsapp: 'https://wa.me/56967130127',
  emails: {
    hello: 'hello@bisonagents.com',
    legal: 'legal@bisonagents.com',
    billing: 'billing@bisonagents.com',
    support: 'support@bisonagents.com',
    admin: 'admin@bisonagents.com',
    brand: 'brand@bisonagents.com',
    social: 'social@bisonagents.com',
  },
  social: [
    {
      id: 'linkedin',
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/bisonagents/',
      handle: '/bisonagents',
    },
    {
      id: 'x',
      label: 'X',
      href: 'https://x.com/bisonagents/',
      handle: '@bisonagents',
    },
    {
      id: 'instagram',
      label: 'Instagram',
      href: 'https://www.instagram.com/bisonagents/',
      handle: '@bisonagents',
    },
    {
      id: 'facebook',
      label: 'Facebook',
      href: 'https://www.facebook.com/bisonagents/',
      handle: '/bisonagents',
    },
    {
      id: 'reddit',
      label: 'Reddit',
      href: 'https://www.reddit.com/user/bisonagents',
      handle: 'u/bisonagents',
    },
    {
      id: 'bluesky',
      label: 'Bluesky',
      href: 'https://bsky.app/profile/bisonagents.com',
      handle: '@bisonagents.com',
    },
    {
      id: 'tiktok',
      label: 'TikTok',
      href: 'https://www.tiktok.com/@bisonagents',
      handle: '@bisonagents',
    },
    {
      id: 'youtube',
      label: 'YouTube',
      href: 'https://www.youtube.com/@bisonagents',
      handle: '@bisonagents',
    },
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      href: 'https://wa.me/56967130127',
      handle: '+56 9 6713 0127',
    },
    {
      id: 'crunchbase',
      label: 'Crunchbase',
      href: 'https://www.crunchbase.com/organization/bison-agents',
      handle: '/bison-agents',
    },
  ],
  founded: '2025-10',
  areaServed: ['CL', 'MX', 'CO', 'AR', 'PE', 'UY', 'BR'],
  // Segmentos en cartera: la lista de /casos y el conteo de /casos y /nosotros salen de aquí.
  segments: [
    'SaaS B2B',
    'E-commerce',
    'Fintech',
    'D2C',
    'Salud & Wellness',
    'EdTech',
    'Servicios profesionales',
    'PropTech',
    'Turismo & Hospitalidad',
    'Movilidad & AutoTech',
    'Seguros',
    'Logística',
    'HR Tech',
    'MarTech & Agencias',
    'Construcción & ConTech',
    'Manufactura B2B',
  ],
  docIds: {
    terminos: 'DOC-LEGAL-001',
    privacidad: 'DOC-LEGAL-002',
    cookies: 'DOC-LEGAL-003',
    cookiesVigencia: '6 oct 2026',
    // Términos: v1.0 (14 may 2026) → v1.1 (6 oct 2026) → v1.2 (12 oct 2026, aclaración de planes en §05).
    // Privacidad: v1.0 (14 may 2026) → v1.1 (6 oct 2026).
    versionTerminos: '1.2',
    vigenciaTerminos: '12 oct 2026',
    versionPrivacidad: '1.1',
    vigenciaPrivacidad: '6 oct 2026',
  },
};
